import {Tooltip} from '@mui/material';
import Grid from '@mui/material/Grid';

import {EMMAI_FORMS} from '../../../../../../const';
import useEmmai from '../../../../../../hooks/providers/useEmmai';
import {PractitionerItem} from '../components/PractitionerItem/PractitionerItem';
import ScrollableRow from '../components/ScrollableRow/ScrollableRow';
import useDefaultPractitioner from '../hooks/useDefaultPractitioner/useDefaultPractitioner';

export default () => {
  const {emmaiData, selectedPractitionerId, setSelectedPractitionerId, currentForm, isPractitionerUpdating} = useEmmai();
  const {practitioners = []} = emmaiData;

  const isDisabled = currentForm === EMMAI_FORMS.ADD_OR_UPDATE_PRACTITIONER;

  useDefaultPractitioner(practitioners, setSelectedPractitionerId);

  return (
    <Tooltip placement="top" title={isDisabled ? 'Vous ne pouvez pas sélectionner un praticien pendant la création et la modification' : ''}>
      <Grid
        container
        alignItems="center"
        sx={{
          maxWidth: {
            xs: '60%',
            sm: '50%'
          }
        }}
      >
        <ScrollableRow items={practitioners}>
          {practitioners.map((p, i) => (
            <PractitionerItem
              key={p.practitioner_id}
              practitioner={p}
              isSelected={p.practitioner_id === selectedPractitionerId}
              isDisabled={isDisabled}
              showSeparator={i < practitioners.length - 1}
              onSelect={() => setSelectedPractitionerId(p.practitioner_id)}
            />
          ))}
        </ScrollableRow>
      </Grid>
    </Tooltip>
  );
};
